import axios from "axios";

const API = axios.create({
  // Your backend URL
  baseURL: "https://delight-backend-1t97.onrender.com/api",
});

// Automatically add the token to the header of every request
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

export default API;